import * as React from 'react';
import PropTypes from 'prop-types';
import './Skeleton.scss';

const Skeleton = ({
  className,
  width = '100%',
  height,
  style,
  margin = '12px',
}) => {
  return (
    <div
      className={`skeleton ${className}`}
      style={{ ...style, height, width, margin }}
    >
    </div>
  );
};

Skeleton.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object,
  height: PropTypes.string,
  margin: PropTypes.string,
};

export default Skeleton;
